import { render, staticRenderFns } from "./CategoryRange.vue?vue&type=template&id=084c4cf5&scoped=true"
import script from "./CategoryRange.vue?vue&type=script&lang=js"
export * from "./CategoryRange.vue?vue&type=script&lang=js"
import style0 from "./CategoryRange.vue?vue&type=style&index=0&id=084c4cf5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c4cf5",
  null
  
)

export default component.exports